<template>
  <div class="stock"
    :class="inStock(product) ? 'in-stock' : runningOut(product) ? 'running-out' : 'out-of-stock'"
    :data-closed="!open"
  >
    <div class="main">
      <span>
        {{ inStock(product) ? 'In Stock' : runningOut(product) ? 'Running Out' : 'Out Of Stock' }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProductStockDisplay',
    props: {
      product: {
        type: Object,
        default: () => {}
      },
      open: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      inStock(product) {
        return product.stock > 4;
      },
      runningOut(product) {
        return !this.inStock(product) && product.stock >= 1;
      },
      outOfStock(product) {
        return product.stock === 0;
      },
    }
  }
</script>

<style lang="scss" scoped>
$open-width: 115px;
$open-height: 35px;

$in-stock-color: $green;
$running-out-color: $orange;
$out-of-stock-color: $red;

$transparent-amount: .85;
$darken-amount: 20;
.stock {
  width: $open-width;
  height: $open-height;
  border-radius: 5px;
  background-color: transparent;
  transition: $transition-fast-out;
  transition-delay: .25s;

  .main {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.in-stock {
    .main {
      color: darken($in-stock-color, $darken-amount);
      background-color: transparentize($in-stock-color, $transparent-amount);
    }
  }
  &.running-out {
    .main {
      color: darken($running-out-color, $darken-amount);
      background-color: transparentize($running-out-color, $transparent-amount);
    }
  }
  &.out-of-stock {
    .main {
      color: darken($out-of-stock-color, $darken-amount);
      background-color: transparentize($out-of-stock-color, $transparent-amount);
    }
  }

  &[data-closed] {
    position: absolute;
    left: .5rem;
    top: .5rem;
    opacity: 0.8;
    width: 24px;
    height: 24px;
    padding: 1px;
    border: 2px solid;

    .main {
      color: white;
      transition: inherit;
      transition-delay: 0s;
      border-radius: inherit;
      
      span {
        opacity: 0;
        transition: inherit;
      }
    }

    &.in-stock {
      .main {
        background-color: $in-stock-color;
      }
    }
    &.running-out {
      .main {
        background-color: $running-out-color;
      }
    }
    &.out-of-stock {
      .main {
        background-color: $out-of-stock-color;
      }
    }
  }

  &.in-stock {
    border-color: $in-stock-color;
  }
  &.running-out {
    border-color: $running-out-color;
  }
  &.out-of-stock {
    border-color: $out-of-stock-color;
  }

  &:hover {
    opacity: 1;
    width: $open-width;
    height: $open-height;
    transition-delay: 0s;

    .main {
      transition-delay: .25s;
      
      span {
        opacity: 1;
      }
    }
  }
}
</style>

<style lang="scss">
$in-stock-color: $green;
$running-out-color: $orange;
$out-of-stock-color: $red;

.theme-dark .stock {
  &.in-stock {
    .main {
      color: $in-stock-color !important;
      // background-color: transparentize($in-stock-color, $transparent-amount);
    }
  }
  &.running-out {
    .main {
      color: $running-out-color !important;
      // background-color: transparentize($running-out-color, $transparent-amount);
    }
  }
  &.out-of-stock {
    .main {
      color: $out-of-stock-color !important;
      // background-color: transparentize($out-of-stock-color, $transparent-amount);
    }
  }

  &[data-closed] .main {
    color: white !important;
  }
}
</style>
